<template>
    <div class="notice-popup-container">
        <div v-for="(notice, index) in notices" :key="notice.id" class="notice-popup" :style="popupStyle(index)">
            <div class="popup-header">
                <span class="popup-title">{{ notice.title }}</span>
            </div>
            <div class="popup-body">
                {{ notice.message }}
            </div>
            <div id="popup-footer">
                <label class="toggle-label">
                    <input type="checkbox" v-model="hideToday[index]">
                    오늘 하루 다시 보지 않기
                </label>
                <button class="notice_close_button" @click="closeAndHideToday(notice.id, index)">
                    닫기
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['notices'],
    data() {
        return {
            hideToday: [] // 각 팝업별로 오늘 하루 다시 보지 않기 토글 상태를 배열로 관리
        };
    },
    methods: {
        popupStyle(index) {
            const baseDistance = 100; // 초기 거리
            const distanceMultiplier = 35; // 거리 배수

            return {
                top: `${baseDistance + index * distanceMultiplier}px`,
                left: `${baseDistance + index * distanceMultiplier}px`,
                zIndex: 1000 + index,
            };
        },
        closeAndHideToday(noticeId, popupIndex) {
            this.$emit('remove', noticeId);
            if (this.hideToday[popupIndex]) {
                const data = {
                    date: Date.now()
                };
                localStorage.setItem(noticeId, JSON.stringify(data));
                console.log(noticeId + " : " + JSON.stringify(data));
            }
        },
        closeAllPopups() {
            // 모든 팝업 닫기
            this.notices.forEach((notice, index) => {
                this.closeAndHideToday(notice.id, index);
            });
        }
    }
};
</script>

<style>
.notice-popup-container {
    width: 100%;
    height: auto;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column-reverse;
    /* 팝업이 추가될 때 역순으로 배치 */
    align-items: flex-start;
    /* 좌측 상단으로 정렬 */
    padding: 20px;
    /* 좌측 상단 여백 */
    pointer-events: none;
}

.notice-popup {
    position: absolute;
    background-color: black;
    /* 배경 검은색으로 설정 */
    color: white;

    border-radius: 5px;
    width: 400px;
    /* 팝업 너비 조정 */
    max-width: 80%;
    /* 최대 너비 설정 */
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    /* 그림자 효과 추가 */
    border: 1px solid white;
    /* 흰색 테두리 추가 */
    transition: transform 0.3s ease, opacity 0.3s ease;
    display: flex;
    flex-direction: column;
    pointer-events:all;
}

.popup-header {
    padding: 10px 5px 5px 5px;
    flex: 3;
    font-size: 1.1em;
    font-weight: bold;
    height: 50px;
    background-color: #2d88ff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: 1px solid #ccc;
}

.popup-body {
    flex: 5;
    margin-top: 10px;
    padding: 20px;
}

.toggle-label {
    display: flex;
    align-items: center;
}

.toggle-label input[type="checkbox"] {
    margin-right: 8px;
    /* 체크박스 오른쪽 간격 설정 */
}

.toggle-label span {
    margin-right: 8px;
    /* 텍스트 오른쪽 간격 설정 */
}

#popup-footer {
    padding: 5px;
    flex: 2;
    margin-top: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* 내용과 버튼을 양쪽 끝에 배치 */
    border-top: 1px solid #ccc;
    /* 상단 구분선 추가 */
}

.notice_close_button {
    height: 60%;
    font-size: 1em;
    background-color: #2d88ff;
    /* 버튼 배경색 설정 */
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.notice_close_button:hover {

    background-color: #1c6de9;
    /* 버튼 호버 배경색 설정 */
}
</style>